// extracted by mini-css-extract-plugin
module.exports = {"default":"List-module--default--3CpzA","inline":"List-module--inline--1KPxj","menu":"List-module--menu--1Gid_"};